import type { RovoTargetingEvaluation } from './eligibility';
import type { RovoTargetingAudienceEvent } from './types';

export const buildRovoTargetingAudienceEvent = ({
	outcome,
	rollout,
	signal,
	reason,
	durationMs,
}: RovoTargetingEvaluation & { rollout: 'enabled' | 'disabled' }): RovoTargetingAudienceEvent => ({
	type: 'sendOperationalEvent' as const,
	data: {
		source: 'rovoTargeting' as const,
		action: 'evaluated' as const,
		actionSubject: 'rovoTargeting' as const,
		attributes: {
			outcome,
			rollout,
			definitionVersion: 'v1',
			signal,
			reason,
			...(durationMs === undefined ? {} : { durationMs }),
		},
	},
});
